// extracted by mini-css-extract-plugin
export default {"hovereffect":"ImageHover_hovereffect__zPvmz","overlay":"ImageHover_overlay__ChX53"};